import { useQuery } from "@tanstack/react-query";
import { useAxios } from "auth-sdk";
import { CashAdvancesCustomerSchemas, OffersSchemas } from "api-types";
import type { AxiosResponse } from "axios";
import { useMemo } from "react";

import { useOfferRequestPath } from "../hooks/use-offer-request-path";
import { combineOfferAndCashAdvance } from "../utils/utils";

export const useGetOfferCollectionScheduleQuery = (
  offer: OffersSchemas.OfferDisplaySchema,
  cashAdvance?: CashAdvancesCustomerSchemas.CashAdvanceSummarySchema
) => {
  const client = useAxios();
  const requestPath = useOfferRequestPath().getCollectionSchedule();
  const params = useMemo(() => combineOfferAndCashAdvance(offer, cashAdvance), [offer, cashAdvance]);

  return useQuery({
    queryKey: ["getOfferCollectionSchedule", params],
    queryFn: () => client.post<CashAdvancesCustomerSchemas.TrancheCollectionParamsIn>(requestPath, params),
    select: ({ data }: AxiosResponse): CashAdvancesCustomerSchemas.ProjectedAdvanceCollectionScheduleOut => data,
    throwOnError: true,
    enabled: !!params && params.tranches.length > 0,
  });
};
